<template>
  <div class="wrapPop" v-if="showPop">
    <div class="popbg">
      <img
        class="popimg"
        @click="callbackIos"
        :src="popData.pic_url"
        alt=""
      />
      <div class="btn" @click="checkBtn">
        <img :src="checkUrl" alt="" v-if="popData.push_close_type == 1 || popData.push_close_type == 2" />
        <span v-if="popData.push_close_type == 1">今日不再推送</span>
        <span v-if="popData.push_close_type == 2">本次活动不再推送</span>
      </div>
    </div>
    <img
        class="closeImg"
        @click="closePop"
        src="../assets/imgs/close.png"
        alt=""
      />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mixServerConfig } from '../config';
import { pushPopReport} from '@/api/mixServer';
export default {
  name: "pushpop",
  data() {
    return {
      config: "",
      themeCfg: "",
      isCheck: false,
      checkUrl: require("../assets/imgs/check.png"),
      popData: {},
      reportType: "",
      showPop: false
    };
  },
  created() {
    // this.getPushPopConfig();
  },
  computed: {
    ...mapState(['pushImgShow', 'pushImgConfig']),
  },
  watch: {
    pushImgShow(val) {
        this.showPop = val;
    },
    pushImgConfig: {
    handler(newVal) {
      if (newVal && newVal.is_popup) {
        this.popData = newVal;
        this.getPushPopConfig();
      }
    },
    immediate: true // 如果需要在初始化时立即执行，可以加上这个选项
  }
  },
  methods: {
    getPushPopConfig() {
      if (this.popData.push_node == 0) {
        this.reportType = 4;
        this.reportPop();
      }
    },
    checkBtn() {
      this.isCheck = !this.isCheck;
      if (this.isCheck) {
        this.checkUrl = require("../assets/imgs/checked.png");
      } else {
        this.checkUrl = require("../assets/imgs/check.png");
      }
    },
    // 点链接跳转通知ios
    callbackIos() {
      if (this.popData.url) {
        this.reportType = 0;
        this.reportPop();
        try {
          window.webkit.messageHandlers['receiveUrlData'].postMessage({ params: [this.popData.url] }); 
        } catch (err) {
          console.log(err, '浏览器不支持跳转')
          window.open(this.popData.url, '_blank')
        }
      }
    },
    closePop() {
      console.log('关闭了')
      if (!this.popData.url) {
        this.reportType = 3;
        this.reportPop(1);
      }
      if (this.popData.push_close_type != 0 && this.popData.url) {
        if (this.isCheck) {
          this.reportType = this.popData.push_close_type;
          this.reportPop(1);
        } else {
            this.$store.commit('SET_PUSHSHOW', false);
        }
      }
      if (this.popData.push_close_type != 0 && !this.popData.url) {
        if (this.isCheck) {
          this.reportType = this.popData.push_close_type;
          this.reportPop(1);
        } else {
          this.reportType = 3;
          this.reportPop(1);
        }
      }
    },

    // 弹窗点击上报
    reportPop(action) {
      const params = {
        access_token: mixServerConfig.access_token,
        type: this.reportType,
        rule_id: this.popData.rule_id,
      };
      pushPopReport(params).then((res) => {
        console.log(res);
        if (action) {
          this.$store.commit('SET_PUSHSHOW', false);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wrapPop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3001;
}
.popbg {
  width: 100%;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.popimg {
  width: 70%;
}
.wrapPop .btn {
 margin: -5vh auto;
}
.wrapPop .btn img {
  width: 20px;
  vertical-align: middle;
}
.wrapPop .btn span {
  color: #fff;
  font-size: 0.85em;
  vertical-align: middle;
  margin-left: 6px;
}
.closeImg {
  position: absolute;
  left: 50%;
  top: 12vh;
  width: 26px;
  transform: translate(0,-50%);
}
</style>
